import { ApplicationRoutes } from "../../routes";
import { MenuItemData } from "../menu.types";
import {
	BillsDashboardIcon,
	BillsDashboardActiveIcon,
	VendingIcon,
	VendingActiveIcon,
	PostpaidIcon,
	PostpaidActiveIcon,
	SettingsIcon,
	SettingsActiveIcon,
	ServiceRequestsActiveIcon,
	ServiceRequestsIcon,
	BulkPurchaseIcon,
	BulkPurchaseInactiveIcon,
	ActivityLogIcon,
	ActivityLogActiveIcon,
	RetryIcon,
} from "../../assets/icons";
import {
	AuditLogMenuActiveIcon,
	AuditLogMenuIcon,
	CustomerMenuActiveIcon,
	CustomerMenuIcon,
	ReconcilliationMenuIcon,
	DepartmentsActiveIcon,
	DepartmentsIcon,
	WorkflowsMenuActiveIcon,
	WorkflowsMenuIcon,
	StepsMenuIcon,
	StepsMenuActiveIcon,
	SystemReferralMenuIcon,
	SystemReferralMenuIconActive,
} from "../../assets/sidemenu-icons";
import { UtilityPermissions } from "../../model/permissions/permissions";

export const MENU_STRUCTURE = {
	// Bills Payment & Operations Management Module Menu
	billsOperationsMenu: [
		{
			text: "Dashboard",
			icon: <BillsDashboardIcon />,
			isActiveIcon: <BillsDashboardActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.DASHBOARD}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Vending History",
			icon: <VendingIcon />,
			isActiveIcon: <VendingActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.VENDING_HISTORY}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewPrepaidTransactions,
		},
		{
			text: "Postpaid History",
			icon: <PostpaidIcon />,
			isActiveIcon: <PostpaidActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.POSTPAID_HISTORY}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewPostpaidTransactions,
		},
		{
			text: "Bulk Purchase",
			icon: <BulkPurchaseInactiveIcon />,
			isActiveIcon: <BulkPurchaseIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.BULK_PURCHASE}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Customer 360° View",
			icon: <CustomerMenuIcon />,
			isActiveIcon: <CustomerMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.CUSTOMER_360}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewCustomerTable,
		},
		{
			text: "Reconciliation",
			icon: <ReconcilliationMenuIcon />,
			isActiveIcon: <ReconcilliationMenuIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.RECONCILLIATION}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewReconcilliation,
		},
		{
			text: "Refunds",
			icon: <RetryIcon />,
			isActiveIcon: <RetryIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.BILLS_OPERATIONS}/${ApplicationRoutes.REFUNDS}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewRefunds,
		},
	] as MenuItemData[],

	// Service Request Module Menu
	serviceRequestMenu: [
		{
			text: "Dashboard",
			icon: <BillsDashboardIcon />,
			isActiveIcon: <BillsDashboardActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.DASHBOARD}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Activity Log",
			icon: <ActivityLogIcon />,
			isActiveIcon: <ActivityLogActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.ACTIVITY_LOG}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Service Request",
			icon: <ServiceRequestsIcon />,
			isActiveIcon: <ServiceRequestsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.SERVICE_REQUEST}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Workflow Manager",
			icon: <WorkflowsMenuIcon />,
			isActiveIcon: <WorkflowsMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.WORKFLOWS_MANAGMENT}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Steps",
			icon: <StepsMenuIcon />,
			isActiveIcon: <StepsMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.STEPS}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: 'System Referral',
			icon: <SystemReferralMenuIcon/>,
			isActiveIcon: <SystemReferralMenuIconActive/>,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.REFERAL_SYSTEM}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewReferral,
		},
		{
			text: "Audit Log",
			icon: <AuditLogMenuIcon />,
			isActiveIcon: <AuditLogMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.AUDIT_LOG}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewAuditLogs,
		},
		{
			text: "Settings",
			icon: <SettingsIcon color="#17171780" height={26} width={26} />,
			isActiveIcon: <SettingsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.SETTINGS}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewUtilitySettings,
		},
		{
			text: "Departments",
			icon: <DepartmentsIcon />,
			isActiveIcon: <DepartmentsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.SERVICE_REQUEST_MODULE}/${ApplicationRoutes.DEPARTMENT_CONFIGURATION}`,
			subMenuItems: [],
			disabled: false,
		},
	] as MenuItemData[],

	// Customer Support Module Menu
	customerSupportMenu: [
		{
			text: "All Service Request Instances",
			icon: <ServiceRequestsIcon />,
			isActiveIcon: <ServiceRequestsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CUSTOMER_SUPPORT}/${ApplicationRoutes.ALL_INSTANCES}`,
			subMenuItems: [],
			disabled: false,
			activeOnRoutes: [
				`/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CUSTOMER_SUPPORT}/${ApplicationRoutes.REPORT_SERVICE_REQUEST}`,
			],
		},
		// {
		// 	text: "Track Service Request",
		// 	icon: <ServiceRequestsIcon />,
		// 	isActiveIcon: <ServiceRequestsActiveIcon />,
		// 	route: `${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CUSTOMER_SUPPORT}/${ApplicationRoutes.TRACK_SERVICE_REQUEST}`,
		// 	subMenuItems: [],
		// 	disabled: false,
		// },
	] as MenuItemData[],

	// Client Management Module Menu
	clientManagementMenu: [
		{
			text: "Customer 360° View",
			icon: <CustomerMenuIcon />,
			isActiveIcon: <CustomerMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CLIENT_MANAGEMENT}/${ApplicationRoutes.CUSTOMER_360}`,
			subMenuItems: [],
			disabled: false,
			permission: UtilityPermissions.ViewCustomerTable,
		},
		{
			text: "Customer Profile",
			icon: <CustomerMenuIcon />,
			isActiveIcon: <CustomerMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CLIENT_MANAGEMENT}/${ApplicationRoutes.CUSTOMER_PROFILE}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Meters & Accounts",
			icon: <CustomerMenuIcon />,
			isActiveIcon: <CustomerMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CLIENT_MANAGEMENT}/${ApplicationRoutes.METERS_ACCOUNTS}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Billing History",
			icon: <CustomerMenuIcon />,
			isActiveIcon: <CustomerMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CLIENT_MANAGEMENT}/${ApplicationRoutes.BILLING_HISTORY}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Service Request History",
			icon: <ServiceRequestsIcon />,
			isActiveIcon: <ServiceRequestsActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CLIENT_MANAGEMENT}/${ApplicationRoutes.SERVICE_REQUEST_HISTORY}`,
			subMenuItems: [],
			disabled: false,
		},
		{
			text: "Interaction Logs",
			icon: <AuditLogMenuIcon />,
			isActiveIcon: <AuditLogMenuActiveIcon />,
			route: `/${ApplicationRoutes.ADMIN_UTIL_BASE}/${ApplicationRoutes.CLIENT_MANAGEMENT}/${ApplicationRoutes.INTERACTION_LOGS}`,
			subMenuItems: [],
			disabled: false,
		},
	] as MenuItemData[],
};
